<template>
	<div class="card">
		<div class="card-header">
			<span class="fs-5">Data Pengguna Presensi</span>
		</div>
		<div class="card-body p-0" v-loading="loading">
			<el-tabs v-model="activeTab" type="border-card" @tab-click="handleTabClick" :before-leave="beforeLeaveTab" class="rounded-bottom border-0">
				<el-tab-pane label="Guru" name="pengguna-guru" />
				<el-tab-pane label="Tenaga Kependidikan" name="pengguna-karyawan" />
				<el-tab-pane label="Siswa" name="pengguna-siswa" />
				<el-tab-pane label="Non-GTK" name="pengguna-non-gtk" />
				<router-view :update-editing="updateEditing" :list-sesi="listSesi" :modal-width="modalWidth" v-slot="{ Component }">
					<transition name="fade" mode="out-in">
						<div v-if="routeName === 'pengguna'" class="row g-3">
							<div class="text-center" v-if="loading">Memuat...</div>
							<div class="text-center" v-else-if="userPresensi.length === 0">Data tidak ditemukan</div>
							<div v-for="up in userPresensi" :key="up.type" class="col-12 col-sm-6 col-md-4 col-lg-3" v-else>
								<div class="card">
									<div class="card-header small">
										{{ userTypes[up.type]?.label || "lainnya" }}
										<router-link :to="{ name: userTypes[up.type]?.name || 'pengguna' }">
											<el-icon><i class="bi bi-box-arrow-in-up-right"></i></el-icon>
										</router-link>
									</div>
									<div class="card-body">
										<div class="d-flex gap-1 align-items-baseline">
											<transition name="slide-up" mode="out-in">
												<span class="fs-5" :key="up.jumlah">
													{{ up.jumlah }}
												</span>
											</transition>
											pengguna
										</div>
									</div>
								</div>
							</div>
						</div>
						<component :is="Component" v-else />
					</transition>
				</router-view>
			</el-tabs>
		</div>
	</div>
</template>

<script>
export default {
	name: "PenggunaView",
	data() {
		return {
			userPresensi: [],
			userTypes: {
				guru: { label: "Guru", name: "pengguna-guru" },
				karyawan: { label: "Tenaga Kependidikan", name: "pengguna-karyawan" },
				non_gtk: { label: "Non-GTK", name: "pengguna-non-gtk" },
				siswa: { label: "Siswa", name: "pengguna-siswa" },
			},
			loading: true,
			activeTab: "",
			isEditing: false,
			listSesi: [],
			modalWidth: "50%",
		};
	},
	computed: {
		routeName() {
			return this.$route.name;
		},
	},
	watch: {
		routeName: {
			immediate: true,
			handler(val) {
				if (val !== "pengguna") this.loading = false;

				this.activeTab = val;
			},
		},
	},
	mounted() {
		this.handleResize();
		window.addEventListener("resize", this.handleResize);
		window.addEventListener("beforeunload", this.handleBeforeUnload);
		this.$ws.main.on("user:guru:inserted", this.insertedUser);
		this.$ws.main.on("user:karyawan:inserted", this.insertedUser);
		this.$ws.main.on("user:non-gtk:inserted", this.insertedUser);
		this.$ws.main.on("user:siswa:inserted", this.insertedUser);
		this.$ws.main.on("user:deleted", this.deletedUser);
		this.getJumlahUserPresensi();
		this.getListSesi();
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.handleResize);
		window.removeEventListener("beforeunload", this.handleBeforeUnload);
		this.$ws.main.off("user:guru:inserted");
		this.$ws.main.off("user:karyawan:inserted");
		this.$ws.main.off("user:non-gtk:inserted");
		this.$ws.main.off("user:siswa:inserted");
		this.$ws.main.off("user:deleted");
	},
	methods: {
		insertedUser(data) {
			const d = JSON.parse(data);

			const idx = this.userPresensi.findIndex((up) => up.type === d.type);

			if (idx !== -1) {
				this.userPresensi[idx] = {
					...this.userPresensi[idx],
					jumlah: this.userPresensi[idx].jumlah + 1,
				};
				return;
			}
		},
		deletedUser(data) {
			const d = JSON.parse(data);

			const idx = this.userPresensi.findIndex((up) => up.type === d.type);

			if (idx !== -1) {
				this.userPresensi[idx] = {
					...this.userPresensi[idx],
					jumlah: this.userPresensi[idx].jumlah - 1,
				};
				return;
			}
		},
		updateEditing(val) {
			this.isEditing = val;
		},
		handleTabClick(val) {
			this.$router.push({ name: val.paneName });
		},
		beforeLeaveTab() {
			return new Promise((resolve, reject) => {
				if (this.isEditing) {
					reject();
				}
				resolve();
			});
		},
		handleBeforeUnload(e) {
			if (this.isEditing) {
				e.preventDefault();
				e.returnValue = "";
				return "";
			}
		},
		handleResize() {
			const w = window.innerWidth;
			if (w < 500) this.modalWidth = "90%";
			else if (w < 768) this.modalWidth = "80%";
			else if (w < 992) this.modalWidth = "60%";
			else if (w < 1200) this.modalWidth = "45%";
			else if (w < 1500) this.modalWidth = "35%";
			else if (w < 1920) this.modalWidth = "30%";
			else this.modalWidth = "25%";
		},
		async getJumlahUserPresensi() {
			try {
				const { data } = await this.$defaultApi.post("/user/count");

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.userPresensi = data.jumlah_user;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			} finally {
				this.loading = false;
			}
		},
		async getListSesi() {
			try {
				const { data } = await this.$defaultApi.post("/wa/sessions/list");

				this.listSesi = data.list_sesi;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			}
		},
	},
};
</script>

<style scoped></style>
